export default __webpack_public_path__ + "static/media/hc-10.6aef00e3.mp4";